module.exports = __webpack_public_path__ + "static/img/dropoff-kerry-logo.a3f5f357.jpeg";